module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('figure', [_c('p', {
    staticClass: "image2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Rank-and-file members...",
      "height": "388",
      "src": "images/f0viii-01.jpg",
      "width": "466"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Rank-and-file members of SITRABI, Morales, Izabal, Guatemala, at a COSIBAH workshop on domestic violence, November 2002")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b55af9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Image1.vue
// module id = 72
// module chunks = 0